// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';
import t from './types';

export function usePoTrackingList(props?) {
  return useRequestQuery(
    [t.PO_TRACKING_LIST],
    { method: 'get', url: 'sales/po' },
    {
      select: (res) => res.data.data ?? [],
      defaultData: [],
      ...props,
    },
  );
}

export function usePoTrackingOrder(poOrderId, props?) {
  return useRequestQuery(
    [t.PO_TRACKING_ORDER, poOrderId],
    { method: 'get', url: `sales/po/order/${poOrderId}` },
    {
      enabled: !!poOrderId,
      select: (res) => res.data.data ?? {},
      defaultData: {},
      ...props,
    },
  );
}

export function useCreatePoTracking(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([poOrderId, values]) => apiRequest.post(`sales/po/order/${poOrderId}/tracking`, values),
    {
      onSuccess: (_response, [poOrderId]) => {
        queryClient.invalidateQueries(t.PO_TRACKING_LIST);
        queryClient.invalidateQueries([t.PO_TRACKING_ORDER, poOrderId]);
        queryClient.invalidateQueries('SALES_ORDER_ACCOUNTING');
        queryClient.invalidateQueries(['SALES_ORDER_ACCOUNTING']);
      },
      ...props,
    },
  );
}

export function useDeletePoTracking(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([poOrderId, trackingId]) =>
      apiRequest.delete(`sales/po/order/${poOrderId}/tracking/${trackingId}`),
    {
      onSuccess: (_response, [poOrderId]) => {
        queryClient.invalidateQueries(t.PO_TRACKING_LIST);
        queryClient.invalidateQueries([t.PO_TRACKING_ORDER, poOrderId]);
        queryClient.invalidateQueries('SALES_ORDER_ACCOUNTING');
        queryClient.invalidateQueries(['SALES_ORDER_ACCOUNTING']);
      },
      ...props,
    },
  );
}
